import api from '@/api';

const resource = 'ei/professorreports';

export default {
  getDemonstrativoNotasAnalitico(data) {
    return api.get(`${resource}/demonstrativo-notas-analitico`, {
      params: data,
    });
  },
  getDemonstrativoFrequenciaAnalitico(data) {
    return api.get(`${resource}/demonstrativo-frequencia-analitico`, {
      params: data,
    });
  },
  getDemonstrativoFrequenciaAnaliticoSalaAula(data) {
    return api.get(`${resource}/demonstrativo-frequencia-analitico-sala-aula`, {
      params: data,
    });
  },
  getDemonstrativoFrequenciaDia(data) {
    return api.get(`${resource}/demonstrativo-frequencia-dia`, {
      params: data,
    });
  },
  getDemonstrativoNotasConsolidado(data) {
    return api.get(`${resource}/demonstrativo-notas-consolidado`, {
      params: data,
    });
  },
  getDemonstrativoFrequenciaConsolidado(data) {
    return api.get(`${resource}/demonstrativo-frequencia-consolidado`, {
      params: data,
    });
  },
  getDemonstrativoConteudoLecionado(data) {
    return api.get(`${resource}/demonstrativo-conteudo-lecionado`, {
      params: data,
    });
  },
  getDemonstrativoNotasFrequencia(data) {
    return api.get(`${resource}/demonstrativo-notas-frequencia`, {
      params: data,
    });
  },
  getPareceresDescritivos(data) {
    return api.get(`${resource}/pareceres-descritivos`, {
      params: data,
    });
  },
  getPareceresDescritivosAEEouACP(data) {
    return api.get(`${resource}/pareceres-descritivos-aee-acp`, {
      params: data,
    });
  },
  getPerfilTurma(data) {
    return api.get(`${resource}/perfil-turma`, {
      params: data,
    });
  },
  getDemonstrativoConceitoAnalitico(data) {
    return api.get(`${resource}/demonstrativo-conceito-analitico`, {
      params: data,
    });
  },
  getDemonstrativoConceitoConsolidado(data) {
    return api.get(`${resource}/demonstrativo-conceito-consolidado`, {
      params: data,
    });
  },
  getDemonstrativoConceitoFrequencia(data) {
    return api.get(`${resource}/demonstrativo-conceito-frequencia`, {
      params: data,
    });
  },
  getAulasMinistradasExigidas(data) {
    return api.get(`${resource}/aulas-ministradas-exigidas`, {
      params: data,
    });
  },
  getContaGoogleDosAlunos(data) {
    return api.get(`${resource}/alunos-conta-google`, {
      params: data,
    });
  },
};
